const Empty = require('constants/empty');
const { createSelector } = require('reselect');
const { userSelector } = require('selectors/user/userSelector');

const preferredZipCodeSelector = createSelector(userSelector, user => user.preferredZipCode || Empty.String);

module.exports = { preferredZipCodeSelector };
